import { Rate, ServiceRatePricing } from '@mews-commander/data-access';
import { ServiceRateGroupPricingExtended } from '../../../reducers/rateGroups';

export const findRatePriceInRateGroups = (rate: Rate, rateGroups: Record<string, ServiceRateGroupPricingExtended>) => {
    const findRate = (rateId: string) => (ratePrice: ServiceRatePricing & { isRestricted: boolean }) =>
        ratePrice.rateId === rateId;

    return rateGroups[rate.rateGroupId]?.ratePrices.find(findRate(rate.id));
};
